import { createSlice } from "@reduxjs/toolkit";
import {
  // createApplicationAsync,
  fetchApplicationDetailsAsync,
} from "../thunks/ApplicationThunk";
import { STATUS } from "./userDetailslice";

export interface Application {
  id: number;
  name: string;
  userCounts:string;
}

const initialApplicationDetailsState: ApplicationDetailsState = {
  ApplicationList: null,
  status: STATUS.IDLE,
  loading: false,
  error: null,
};

interface ApplicationDetailsState {
  ApplicationList: Application[] | null;
  status: string;
  loading: boolean;
  error: string | null;
}

const applicationDetailsSlice = createSlice({
  name: "ApplicationDetails",
  initialState: initialApplicationDetailsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationDetailsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationDetailsAsync.fulfilled, (state, action) => {
        state.ApplicationList = action.payload;
        state.loading = false;
      })
      .addCase(fetchApplicationDetailsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? null;
      })
  },
});

export default applicationDetailsSlice.reducer;
